export class MenuItem {
    public icon: string = '';
    public title: string = '';
    public link: string = '';
    public selected: boolean = false;
    public type: string = 'link';
    public cssClass: string = '';
    public actionComponent: any = null;
    public actionBarActive: boolean = false;
    public source: string = '';
    public chatUnreadBubble: boolean = false;

    private callback: Function;

    constructor (data) {
        if (data.hasOwnProperty('icon')) {
            this.icon = data.icon;
        }

        if (data.hasOwnProperty('title')) {
            this.title = data.title;
        }

        if (data.hasOwnProperty('link')) {
            this.link = data.link;
        }

        if (data.hasOwnProperty('selected')) {
            this.selected = data.selected;
        }

        if (data.hasOwnProperty('type')) {
            this.type = data.type;
        }

        if (data.hasOwnProperty('cssClass')) {
            this.cssClass = data.cssClass;
        }

        if (data.hasOwnProperty('actionComponent')) {
            this.actionComponent = data.actionComponent;
        }

        if (data.hasOwnProperty('actionBarActive')) {
            this.actionBarActive = data.actionBarActive;
        }

        if (data.hasOwnProperty('chatUnreadBubble')) {
            this.chatUnreadBubble = data.chatUnreadBubble;
        }

        if (data.hasOwnProperty('source')) {
            this.source = data.source;
        }
    }


    public setCallback(callback: Function) {
        this.callback = callback;
    }

    public triggerCallback() {
        this.callback();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/models/menu-item.ts